<template>
  <div class="account-statement__log">
    <TableComponent
      ref="table"
      :pagination="pagination"
      @updateData="_updateData"
      :routeName="$route.name"
    >
      <template #default="{ handleSelectionChange }">
        <div class="btn-all">
          <el-button class="export-color"> 导出 </el-button>
        </div>
        <el-table
          :data="tableData"
          v-min-height
          @selection-change="handleSelectionChange"
          header-cell-class-name="theader-th"
          cell-class-name="tbody-td"
        >
          <el-table-column fixed type="selection" align="center" width="60" />
          <el-table-column
            align="center"
            label="小程序名称"
            prop="appletName"
            min-width="180"
          />
          <el-table-column
            align="center"
            label="操作时间"
            prop="time"
            min-width="180"
          />
          <el-table-column
            align="center"
            label="操作人"
            prop="operator"
            min-width="180"
          />
          <el-table-column
            align="center"
            label="变化前状态"
            prop="changeStart"
            min-width="180"
          />
          <el-table-column
            align="center"
            label="变化后状态"
            prop="changeEnd"
            min-width="180"
          />
          <el-table-column
            align="center"
            label="操作类型"
            prop="changeType"
            min-width="180"
          />
        </el-table>
      </template>
    </TableComponent>
  </div>
</template>
<script>
import TableComponent from '../../Components/TableComponent'
import updateData from 'mixins/updateData'
import tabsIndex from 'mixins/tabsIndex'

export default {
  name: 'accountStatementLog',
  mixins: [updateData, tabsIndex],
  components: {
    TableComponent,
  },
  data() {
    this.keyMap = {
      log_list: {
        name: 'tableData',
        add_time: 'time',
        app_name: 'appletName',
        change_before_status: 'changeStart',
        change_after_status: 'changeEnd',
        change_type: 'changeType',
        operator: 'operator',
      },
    }
    return {
      tableData: [],
      pagination: {},
    }
  },
  watch: {
    $route: {
      handler(to) {
        const id = to.query.id
        if (id) {
          this._getAccountStatementLogList({
            bill_id: id,
          })
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 获取对账单日志列表
     * @param params
     * @private
     */

    _getAccountStatementLogList(params) {
      this.api.getAccountStatementLogList(params).then((res) => {
        this.utils.setCommonCode(res, this)
      })
    },
  },
}
</script>
